import $ from 'jquery'

import 'babel-polyfill'
import './common/style/ie-notify.less'
import './common/style/config.less'

// import './common/js/ie-notify'
// import './common/js/servlet'


import topNav from './top-nav/index'
import logoInput from './logo-input/index'
import cateNavIndex from './cate-nav-index/index'

$(() => {
    let options = window._DP_HeaderData
    
    // let config = Object.assign({}, defaultConfig, options)
    let config = $.extend({
        'pageType': 'index',
        'tdomain': '//t.dianping.com',
        'sdomain': '//s.dianping.com',
        'isIndexPage': false,
        'isSearchPage': false,
        'isChannelPage': false,
        'isOtherPage': false
    }, options);
    config.tdomain = location.href.indexOf('51ping')> -1 ? location.protocol + '//t.51ping.com' : location.protocol + '//t.dianping.com';
    config.domain = location.href.indexOf('w.51ping.com')> -1 ? location.protocol + '//w.51ping.com' : location.protocol + '//www.dianping.com';
    if (config.channelId && (config.channelId == 'group')) {
        config.sdomain = location.href.indexOf('s.dianping.com') > -1 ? '//s.dianping.com' : '//s.51ping.com';
        config.isOtherPage = true;
    }

    if(config.pageType == 'index' || config.pageType == 'search' || config.pageType == 'channel'){
        if (config.pageType === 'index') {
            config.isIndexPage = true;
        } else if (config.pageType === 'search') {
            config.isSearchPage = true;
        } else {
            config.isChannelPage = true;
        }
    }else{
        throw new Error('页面导航页面类型配置有误，pageType只能为首页(index),搜索页(search),或者频道页(channel)');
    }
    topNav.init(config)
    logoInput.init(config)
    cateNavIndex.init(config)

    if(config.isIndexPage){ // 展示首页页底
        let footerIndex =require ('./footer-index/index')
        footerIndex.init(config)
    }else{ // 展示大搜页页底
        let footCategory = require('./footer-channel/index')
        footCategory.init(config);
    }
})



// WEBPACK FOOTER //
// ./modules/index-nav.js